// Fichier genere par `yarn svg:components` : ne pas modifier a la main.
// Source : public/images/school/menu/view.svg
import * as React from 'react'
import type { SVGProps } from 'react'
const SvgView = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 45 45" {...props}>
    <circle cx={22.403} cy={22.884} r={21.5} stroke="currentColor" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M30.246 22.96c.218.334.338.767.338 1.217s-.12.883-.338 1.217c-1.38 2.053-4.52 6.05-8.186 6.05s-6.807-3.997-8.187-6.05a2.25 2.25 0 0 1-.339-1.217c0-.45.121-.883.339-1.217 1.38-2.053 4.52-6.05 8.187-6.05s6.806 3.997 8.186 6.05"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M22.06 27.407c1.451 0 2.628-1.446 2.628-3.23s-1.177-3.23-2.628-3.23-2.628 1.446-2.628 3.23 1.176 3.23 2.628 3.23"
    />
  </svg>
)
export default SvgView
